(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 12457:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(3114);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var components_patterns_error404__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54961);

/* harmony default export */ __webpack_exports__["default"] = (components_patterns_error404__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 54961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ error404; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/application/context/state.tsx + 1 modules
var state = __webpack_require__(14366);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/components/index.tsx + 206 modules
var components = __webpack_require__(20521);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/patterns/error404/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 930px;\n  margin: 0 auto;\n  padding: 3rem 0 1rem 0;\n\n  @media ",
        " {\n    margin: 0 1rem;\n  }\n\n  @media ",
        " {\n    padding: 1rem 0 1rem 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  header {\n    h1 {\n      color: ",
        ";\n      font-size: 5.8rem;\n      font-family: ",
        ";\n\n      @media ",
        " {\n        margin: 3.9rem 0;\n      }\n    }\n\n    h3 {\n      margin-top: 0.3rem;\n      color: ",
        ";\n      font-size: 2.5rem;\n      font-weight: normal;\n      margin-bottom: 1.5rem;\n      font-family: ",
        ";\n\n      @media ",
        " {\n        font-size: 1.6rem;\n        margin: 1.7rem 0;\n      }\n    }\n  }\n\n  footer {\n    margin-top: 1rem;\n\n    h4 {\n      color: ",
        ";\n      font-size: 2rem;\n      font-weight: bold;\n      margin-top: 1.6rem;\n\n      @media ",
        " {\n        font-size: 1.4rem;\n      }\n    }\n\n    div {\n      display: flex;\n      flex-direction: column;\n      gap: 1.5rem;\n\n      @media ",
        " {\n        gap: 1rem;\n      }\n\n      span {\n        font-size: 1.6rem;\n        color: ",
        ";\n\n        @media ",
        " {\n          font-size: 1.3rem;\n        }\n      }\n\n      a {\n        display: flex;\n        align-items: center;\n        font-size: 1.375rem;\n\n        @media ",
        " {\n          font-size: 0.875rem;\n        }\n\n        svg {\n          margin-right: 0.75rem;\n        }\n      }\n    }\n\n    div + div {\n      margin-top: 1rem;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background: url("https://fcx-s3-fercos-backoffice.ferreiracosta.com/favicon/sadface.svg")\n    no-repeat;\n  background-size: 16.25rem;\n  background-position: 100% 5%;\n\n  @media ',
        " {\n    background-position: 90% 5%;\n    background-size: 95px;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n  display: flex;\n  justify-content: flex-start;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1.375rem;\n  padding: 0px;\n  margin: 0px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.5rem;\n  margin-right: 0.75rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.5rem;\n  margin-right: 0.75rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.5rem;\n  margin-right: 0.75rem;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var Error404Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__Error404Container",
    componentId: "sc-8c2a6664-0"
})(_templateObject(), ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileL);
var Error404Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Error404Wrapper",
    componentId: "sc-8c2a6664-1"
})(_templateObject1(), ui.theme.colors.primary[200], ui.theme.typography.fontFamily.chivo, ui.theme.device.desktopFirst.mobileL, ui.theme.colors.neutral[700], ui.theme.typography.fontFamily.chivo, ui.theme.device.desktopFirst.mobileL, ui.theme.colors.neutral[520], ui.theme.device.desktopFirst.mobileL, ui.theme.device.desktopFirst.mobileL, ui.theme.colors.neutral[520], ui.theme.device.desktopFirst.mobileL, ui.theme.device.desktopFirst.mobileL);
var ImageSadFaceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ImageSadFaceContainer",
    componentId: "sc-8c2a6664-2"
})(_templateObject2(), ui.theme.device.desktopFirst.mobileL);
var GoSearchButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__GoSearchButton",
    componentId: "sc-8c2a6664-3"
})(_templateObject3());
var GoSearchText = (0,styled_components_browser_esm/* default */.ZP)(ui.Text).withConfig({
    displayName: "styles__GoSearchText",
    componentId: "sc-8c2a6664-4"
})(_templateObject4(), ui.theme.colors.primary[200]);
var GoBackIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLeftIcon).attrs({
    color: ui.theme.colors.primary[200]
}).withConfig({
    displayName: "styles__GoBackIcon",
    componentId: "sc-8c2a6664-5"
})(_templateObject5());
var GoHomeIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.HomeIcon).attrs({
    color: ui.theme.colors.primary[200]
}).withConfig({
    displayName: "styles__GoHomeIcon",
    componentId: "sc-8c2a6664-6"
})(_templateObject6());
var GoSearchIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.SearchIcon).attrs({
    color: ui.theme.colors.primary[200]
}).withConfig({
    displayName: "styles__GoSearchIcon",
    componentId: "sc-8c2a6664-7"
})(_templateObject7());

;// CONCATENATED MODULE: ../../packages/components/patterns/error404/index.tsx










var Error404 = function() {
    var router = (0,next_router.useRouter)();
    var handleFocusInputSearch = (0,state/* useAppContext */.b)().handleFocusInputSearch;
    (0,react.useEffect)(function() {
        document.title = "Ops! :(";
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Error404Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("error-404-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSadFaceContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("image-sadface-wrapper")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Error404Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("error-404-wrapper")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-error-404")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Ops!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "N\xe3o encontramos a p\xe1gina que voc\xea procura."
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("footer-error-404")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "O que pode ter acontecido?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "- O endere\xe7o da p\xe1gina foi digitado incorretamente"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "- A p\xe1gina pode estar indispon\xedvel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "O que voc\xea pode fazer?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        target: "_self",
                                        href: "/",
                                        onClick: function() {
                                            return router.back();
                                        }
                                    }, (0,application/* buildTestIds */.Fek)("link-router-back")), {
                                        color: ui.theme.colors.primary[200],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoBackIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoSearchText, {
                                                children: "Voltar para a p\xe1gina anterior"
                                            })
                                        ]
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        target: "_self",
                                        href: "/",
                                        color: ui.theme.colors.primary[200]
                                    }, (0,application/* buildTestIds */.Fek)("link-page-home")), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoHomeIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoSearchText, {
                                                children: "Ir para a p\xe1gina inicial"
                                            })
                                        ]
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        target: "_self",
                                        href: "/"
                                    }, (0,application/* buildTestIds */.Fek)("link-focus-input-search")), {
                                        color: ui.theme.colors.primary[200],
                                        onClick: function() {
                                            return handleFocusInputSearch();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoSearchIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoSearchText, {
                                                children: "Fazer uma nova busca"
                                            })
                                        ]
                                    }))
                                ]
                            })
                        ]
                    }))
                ]
            }))
        }))
    }));
};
/* harmony default export */ var error404 = (Error404);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(12457); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);